import React, { useState, useEffect } from 'react';
import { paymentAPI } from '../../utils/api';
import { DashboardLayout } from '../../components/layout';
import { StatusBadge, Modal, Spinner, EmptyState, Badge, Tabs } from '../../components/ui';
import toast from 'react-hot-toast';

export default function AdminPayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('pending');
  const [sel, setSel] = useState(null);
  const [modal, setModal] = useState(false);
  const [remark, setRemark] = useState('');
  const [processing, setProcessing] = useState(false);

  const load = () => {
    setLoading(true);
    paymentAPI.getAll(tab==='all'?'':tab).then(r=>setPayments(r.data.payments||[])).catch(()=>toast.error('Failed')).finally(()=>setLoading(false));
  };

  useEffect(()=>{ load(); },[tab]);

  const act = async status => {
    setProcessing(true);
    try {
      await paymentAPI.update(sel.id,{status,admin_remark:remark});
      toast.success(`Payment ${status}!`);
      load(); setModal(false); setRemark('');
    } catch { toast.error('Failed'); }
    finally { setProcessing(false); }
  };

  const pending = payments.filter(p=>p.status==='pending').length;

  return (
    <DashboardLayout title="Payment Management" subtitle={`${pending} pending`} isAdmin>
      <div style={{ marginBottom:20 }}>
        <Tabs active={tab} onChange={setTab} tabs={[
          {value:'pending',icon:'⏳',label:`Pending (${pending})`},
          {value:'approved',icon:'✅',label:'Approved'},
          {value:'rejected',icon:'❌',label:'Rejected'},
          {value:'all',icon:'📋',label:'All'},
        ]} />
      </div>

      <div className="card">
        <div className="tbl-wrap">
          <table>
            <thead><tr><th>#</th><th>Student</th><th>Group</th><th>UTR ID</th><th>Amount</th><th>Submitted</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={8} style={{ textAlign:'center',padding:40 }}><Spinner size={30} color="blue" /></td></tr>
                : payments.length===0 ? <tr><td colSpan={8}><EmptyState icon="💰" title={`No ${tab} payments`} /></td></tr>
                : payments.map((p,i) => (
                  <tr key={p.id}>
                    <td style={{ fontFamily:'var(--font-mono)',color:'var(--muted)',fontSize:12 }}>{i+1}</td>
                    <td>
                      <div style={{ fontWeight:600,fontSize:13 }}>{p.full_name}</div>
                      <div style={{ fontSize:11,color:'var(--muted)' }}>{p.email}</div>
                    </td>
                    <td><Badge type="blue">{p.exam_group}</Badge></td>
                    <td style={{ fontFamily:'var(--font-mono)',fontSize:13,fontWeight:600,color:'var(--blue)' }}>{p.utr_id}</td>
                    <td style={{ fontFamily:'var(--font-mono)',fontWeight:700,color:'var(--success)' }}>₹{p.amount}</td>
                    <td style={{ fontSize:11,color:'var(--muted)' }}>{new Date(p.submitted_at).toLocaleString('en-IN',{dateStyle:'short',timeStyle:'short'})}</td>
                    <td><StatusBadge status={p.status} /></td>
                    <td>
                      <button className={`btn ${p.status==='pending'?'btn-primary':'btn-outline'} btn-sm`} onClick={()=>{setSel(p);setModal(true);}}>
                        {p.status==='pending'?'Review →':'View'}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal open={modal} onClose={()=>{setModal(false);setRemark('');}} title="Payment Review" size={500}
        footer={sel?.status==='pending'?<>
          <button className="btn btn-outline" onClick={()=>setModal(false)}>Cancel</button>
          <button className="btn btn-danger" onClick={()=>act('rejected')} disabled={processing}>{processing?<Spinner size={15} color="white"/>:'❌ Reject'}</button>
          <button className="btn btn-success" onClick={()=>act('approved')} disabled={processing}>{processing?<Spinner size={15} color="white"/>:'✅ Approve'}</button>
        </>:<button className="btn btn-outline" onClick={()=>setModal(false)}>Close</button>}>
        {sel&&(
          <div>
            <div style={{ background:'var(--bg)',borderRadius:12,padding:'18px',marginBottom:18 }}>
              <div style={{ display:'flex',alignItems:'center',gap:12,marginBottom:14 }}>
                <div style={{ width:44,height:44,borderRadius:'50%',background:'linear-gradient(135deg,var(--blue),var(--blue-mid))',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:18,fontWeight:700 }}>{sel.full_name[0]}</div>
                <div>
                  <div style={{ fontWeight:700,fontSize:15 }}>{sel.full_name}</div>
                  <div style={{ fontSize:12,color:'var(--muted)' }}>{sel.email} • {sel.phone}</div>
                </div>
              </div>
              {[['Exam Group',sel.exam_group],['UTR / Txn ID',sel.utr_id],['Amount',`₹${sel.amount}`],['Submitted',new Date(sel.submitted_at).toLocaleString('en-IN')]].map(([l,v]) => (
                <div key={l} style={{ display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid var(--border)',fontSize:13 }}>
                  <span style={{ color:'var(--muted)' }}>{l}</span>
                  <strong style={{ fontFamily:l.includes('UTR')?'var(--font-mono)':'inherit',color:'var(--blue)' }}>{v}</strong>
                </div>
              ))}
            </div>
            <div style={{ background:'rgba(245,166,35,0.05)',border:'1px solid rgba(245,166,35,0.18)',borderRadius:9,padding:'11px 13px',marginBottom:14,fontSize:12,color:'#7a5c00' }}>
              📍 Verify UTR <strong>{sel.utr_id}</strong> in your UPI app (danarajmuthu28@okicici) before approving.
            </div>
            {sel.status==='pending'&&(
              <div className="form-group">
                <label className="form-label">Admin Remark (optional)</label>
                <textarea className="form-textarea" placeholder="Note for rejection / any remark..." value={remark} onChange={e=>setRemark(e.target.value)} style={{ minHeight:65 }} />
              </div>
            )}
            {sel.admin_remark&&<div style={{ background:'var(--bg)',borderRadius:9,padding:'11px 13px',fontSize:13 }}><strong>Remark:</strong> {sel.admin_remark}</div>}
          </div>
        )}
      </Modal>
    </DashboardLayout>
  );
}
